export const formatToNumberWithUnitPrefix = (
  value: number,
  locale = "en"
): string => {
  return new Intl.NumberFormat(locale, {
    notation: "compact",
    compactDisplay: "short",
    maximumFractionDigits: 1,
  }).format(value)
}
